/**
 * Erzeugt von scripts/stamp-build.js beim Build - nicht von Hand aendern.
 *
 * Ausserhalb der CI bleibt der Wert leer; die App zeigt dann ersatzweise den
 * Inhaltshash des Haupt-Bundles.
 */
export const BUILD_STAMP = {
  commit: 'e0df9ae6',
} as const;
